// GENERATED by scripts/gen-toolchain-hash.mjs — do not edit by hand.
// The §4.4 toolchainHash of the installed @immediately-run/transpiler (= the
// published tarball). Regenerated on every build (prebuild). The deploy asserts
// this equals the hash the CLI stamps into artifact indexes (G2-8).

export const EMBEDDED_TOOLCHAIN_HASH = '1780f8e8144710615d24a53429d0ed10add9e510c40160ea279ebabdc972f131';
